module.exports = __webpack_public_path__ + "img/analytic.1a84c3c3.png";